import { useRef } from "react";
import { Calendar } from "@phosphor-icons/react";

/**
 * Robuste Datumseingabe: Verwendet direkt das native <input type="date">, damit auf
 * ALLEN Geräten (Handy + Desktop) der Kalender sofort beim Tap/Klick auf das Feld öffnet.
 * Value bleibt ISO YYYY-MM-DD nach außen. Das Icon rechts ist rein dekorativ + Fallback.
 */
export default function DateInput({ value, onChange, required, testid, min, max }) {
  const nativeRef = useRef(null);
  const today = new Date();
  const todayIso = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,"0")}-${String(today.getDate()).padStart(2,"0")}`;
  const resolvedMin = min === "today" ? todayIso : (min || undefined);
  const resolvedMax = max || undefined;

  const openPicker = () => {
    const el = nativeRef.current; if (!el) return;
    try { el.focus(); el.showPicker?.(); } catch (_) {}
  };

  return (
    <div className="relative" onClick={openPicker}>
      <input
        ref={nativeRef}
        type="date"
        value={value || ""}
        min={resolvedMin}
        max={resolvedMax}
        required={required}
        data-testid={testid}
        onChange={(e) => onChange(e.target.value)}
        onClick={(e) => { e.stopPropagation(); openPicker(); }}
        className="h-11 w-full rounded-lg border border-slate-200 pl-3 pr-10 text-sm text-slate-800 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-200 focus:outline-none cursor-pointer bg-white"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 p-2 rounded-md text-slate-500"
      >
        <Calendar size={18} weight="regular" />
      </div>
    </div>
  );
}
